import { Modal } from 'antd';
import deleteOrderFile from '../../../Services/deleteOrderFile';

const { confirm } = Modal;

export default () => async (dispatch) => {

  confirm({
    title: `Are you sure you want to delete this PO file?`,
    content: 'Note: This action cannot be undone',
    okText: 'Yes, Delete it',
    onOk() {
      
      dispatch(deleteOrderFile());
      
    }
  });

}